module.exports = __webpack_public_path__ + "static/media/enterpreneur.0decda3b.svg";